export const INIT_EXCHANGE_API = "/api/v1/core/requests/init";
export const ACCEPT_EXCHANGE_API = (id: number) => {
  return `/api/v1/core/requests/${id}/accept`;
};

export const KYC_URL_API = "/api/v1/core/client-kyciad/form-url-kyciad";
export const KYB_URL_API = "/api/v1/core/client-kyciad/form-url-kyb";
export const PROOF_OF_FUNDS =
  "/api/v1/core/client-kyciad/form-url-proof-of-funds";
export const KYC_URL_ADDRESS = "/api/v1/core/client-kyciad/form-url-address";
export const CURRENCY_ASSET = "/api/v1/rates/assets";

export const CONVERT_CURRENCY = "/api/v1/core/requests/convert";
export const KYC_KUB_STATUS = (id: number) => {
  return `/api/v1/core/requests/${id}/status`;
};

export const LOGIN_URL = "/api/v1/core/client-auth/login";
export const RESET_PASSWORD = "/api/v1/core/client-auth/reset-password";
export const CONFIRM_EMAIL = "/api/v1/core/client-auth/confirm";

export const CLIENT_PROFILE_INFO = "/api/v1/core/clients/profile";
export const CLIENT_REQUESTS = "/api/v1/core/requests";
export const CHANGE_PASSWORD = "/api/v1/core/client-auth/change-password";
export const SETUP_PASSWORD = "/api/v1/core/client-auth/set-password";
export const RESEND_OTP = "/api/v1/core/client-auth/resend-otp";

export const AUTHORIZATION_TOKEN = "Authorization";

export const PASSWORD_STATUS = "/api/v1/core/clients/password/status";
